<template>
  <!-- 车辆登记 -->
  <div class="app-container">
  <el-tabs v-model="activeName" @tab-click="handleTabClick" style="padding-left: 5px;">
     <el-tab-pane label="预约记录" name="one">
      <div class="formBox margbot" ref="searchBox">
        <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="100px" size="mini" style="width: 100%;">
            <div class=" formItemBox">
              <el-form-item label="车辆号牌:" prop="vhcNo">
                <el-input  placeholder="" v-model="searchFrom.vhcNo"></el-input>
              </el-form-item>
            </div>
            <div class="searchBtnBox">
              <el-form-item btnCode="00BP007B001"  >
                <el-button type="primary" @click="searchFn">查询</el-button>
              </el-form-item>
              <el-form-item >
                <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <!--  表格 -->
        <div class="table" :style="{height:h}">
          <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"
                    height="100%" style="width: 100%" center border  class="tableComent">
            <el-table-column  type="index" width="55" label="序号"></el-table-column>
            <el-table-column prop="applyUname"  min-width="120"  label="姓名"></el-table-column>
            <el-table-column property="mobile" min-width="130"  :show-overflow-tooltip="true" label="联系电话"></el-table-column>
            <el-table-column prop="vhcNo"  min-width="220" :show-overflow-tooltip="true" label="车牌号"></el-table-column>
            <el-table-column prop="visitTimeStart"  min-width="160" :formatter="dateFormat" label="到访开始时间"></el-table-column>
            <el-table-column prop="visitTimeEnd"  min-width="170" :formatter="dateFormat"  label="到访结束时间"></el-table-column>
            <el-table-column prop="visitDesc"  min-width="170"  label="来访事由"></el-table-column>
            <el-table-column prop="createUserName"  min-width="170"   label="预约人"></el-table-column>
            <!-- <el-table-column prop="createTime" width="170" :formatter="dateFormat"  label="创建时间"></el-table-column> -->
          </el-table>
        </div>
        <!-- 分页 -->
        <div>
          <el-pagination background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="searchFrom.pageNo"
              :page-sizes="[50,100,200,500]"
              :page-size="searchFrom.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
          </el-pagination>
        </div>
     </el-tab-pane>
     <el-tab-pane label="进厂记录" name="two">
       <div class="formBox margbot" ref="searchBox">
        <el-form :inline="true" :model="searchFrom1" ref="searchFrom1" class="demo-form-inline" label-width="100px" size="mini" style="width: 100%;">
            <div class=" formItemBox">
              <el-form-item label="车辆号牌:" >
                <el-input  placeholder="" v-model="searchFrom1.enterCarNumLikeStr"></el-input>
              </el-form-item>
              <!-- <el-form-item label="进厂时间:" class="item2"  v-if="activeName!='dian'">
                <el-date-picker
                    v-model="searchFrom1.jcTime"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                ></el-date-picker>
              </el-form-item> -->
            </div>
            <div class="searchBtnBox">
              <el-form-item btnCode="00BP007B001"  >
                <el-button type="primary" @click="getList1">查询</el-button>
              </el-form-item>
              <el-form-item >
                <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <!--  表格 -->
        <div class="table" :style="{height:h}">
          <el-table :data="tableList1"  ref="table" v-loading="loading"   bordersize="mini"
                    height="100%" style="width: 100%" center border  class="tableComent">
            <el-table-column  type="index" width="55" label="序号"></el-table-column>
            <el-table-column prop="carNum"  min-width="120"  label="车牌号"></el-table-column>
            <el-table-column property="carTypeStr" min-width="130"  :show-overflow-tooltip="true" label="车辆类型"></el-table-column>
            <el-table-column prop="enterSluiceDevChnname"  min-width="220" :show-overflow-tooltip="true" label="门闸名称"></el-table-column>
            <el-table-column prop="enterTimeStr"  min-width="160"  label="进厂时间"></el-table-column>
            <el-table-column prop="visitTimeEnd"  min-width="170" :formatter="dateFormat"  label="入厂图片">
               <template slot-scope="scope">
                <div>
                  <el-button  type="text" size="mini"  @click="pingzhengFn(scope.row)">查看</el-button>
                </div>
          </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div>
          <el-pagination background
              @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1"
              :current-page="searchFrom1.pageNum"
              :page-sizes="[50,100,200,500]"
              :page-size="searchFrom1.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total1">
          </el-pagination>
        </div>
     </el-tab-pane>
  </el-tabs>
    <el-image-viewer v-if="dialogImg"  :on-close="closeViewer"   :url-list="lookimgList" />
  </div>
</template>

<script>
import { compressImages } from '@/utils/compressImages'
import { visitauditList, findHis, findHisCount } from '@/api/vgs-driver'
import { exportExcel } from '@/utils/fileDown.js'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
  components: {
    ElImageViewer
  },
  data () {
    return {
      activeName: 'one',
      isDisable: false,
      h: '500px',
      total: 0,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total1: 0,
      tableList1: [],
      searchFrom1: {
        pageNum: 1,
        pageSize: 50
      },
      dialogImg: false,
      lookimgList: []
      // btnFlg: [],
      // btnIdArr: [ '00BP007B001', '00BP007B002',
      //   '00BP007B003', '00BP007B004', '00BP007B005', '00BP007B006']
    }
  },
  created () {
    this.getList(this.searchFrom)
    this.getList1()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 285) + 'px'
  },
  methods: {
    // 凭证
    pingzhengFn (row) {
      console.log('https://183.196.57.232:9001/evo-apigw/' + row.realCapturePicPathEnter)
      this.dialogImg = true
      this.$set(this.lookimgList, 0, 'https://183.196.57.232:9001/evo-apigw/' + row.realCapturePicPathEnter)
    },
    closeViewer () {
      this.dialogImg = false
    },
    handleTabClick () {

    },
    // 导出
    exportFn () {
      let form = { ...this.searchFrom }
      exportExcel(
        this.global.driverName + '/vehicle/insideinfo/exportList',
        form,
        '场内车辆管理列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      visitauditList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 获取列表
    getList1 () {
      // if (this.searchFrom1.jcTime) {
      //   this.searchFrom1.enterTimeStrLeft = this.searchFrom1.jcTime[0]
      //   this.searchFrom1.enterTimeStrRight = this.searchFrom1.jcTime[1]
      // } else {
      //   this.searchFrom1.enterTimeStrLeft = ''
      //   this.searchFrom1.enterTimeStrRight = ''
      // }
      this.loading = true
      findHis(this.searchFrom1).then(res => {
        this.loading = false
        this.tableList1 = res.data.pageData
      })
      findHisCount({ enterCarNumLikeStr: this.searchFrom1.enterCarNumLikeStr }).then(res => {
        this.loading = false
        this.total1 = res
      })
    },
    // 每页条数
    handleSizeChange1 (val) {
      this.searchFrom1.pageSize = val
      this.getList()
    },
    // 当前页
    handleCurrentChange1 (val) {
      this.searchFrom1.pageNum = val
      this.getList1()
    },
    resetForm () {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.searchFrom1 = {
        pageNum: 1,
        pageSize: 50
      }
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      if (cellValue) {
        var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
        var month =
          t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
        var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
        var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
        var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
        var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
        return (
          t.getFullYear() +
          '-' +
          month +
          '-' +
          date +
          ' ' +
          hour +
          ':' +
          minutes +
          ':' +
          seconds
        )
      }

      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    },
    dateFormat1: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
          t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      let str = ''
      if (cellValue) {
        str = t.getFullYear() + '-' + month + '-' + date
      }
      return str
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>

<style scoped lang='less'>

  .inpBox .el-date-editor{
    width: 350px!important;
  }
  .imgBox{
    display: flex;
    .item{
      display: flex;
      width: 50%;
      justify-content: space-around;
    }
  }
  .jiaoyan /deep/.el-date-editor {
    width: 150px!important;
  }
  /deep/.jiaoyan .el-date-editor .el-input__inner {
    width: 150px;
  }
  .box{
    display: flex;
    justify-content: space-around;
    .imgBox{
      display: flex;
      flex-direction: column;
      width: 386px;
      height: 290px;
      /deep/.el-upload--picture-card{
        width: 386px;
        height: 240px;
      }
    }
    h6{
      text-align: center;
    }
    /deep/.el-upload--picture-card {
      background-image: url(../../../assets/images/upload1.png);
    }
    /deep/.el-upload-list--picture-card .el-upload-list__item{
      width: 386px;
      height: 240px;
    }
  }
  .loogImgBox{
    display: flex;
    justify-content: space-around;
    .box1{
      width: 48%;
    }
    img{
      width: 100%;
    }
  }

  /deep/.inpBox .bigInp .el-input__inner{
    width: 250px;
  }
  .hidden /deep/.el-upload--picture-card{
      display: none;
    }
/deep/.el-tabs__header{
  margin-bottom: 0;
}
.searchBtnBox{
  margin: 0;
}
</style>
